<template>
  <base-modal class="child-devices-modal"
              :show="show"
              @close="close"
              size="small">
    <div slot="header">
      {{ $t("profileSettings.removeProfile") }}
    </div>

    <div v-if="child"
         class="remove-profile">
      <div v-if="devices.length">
        {{ $t("alerts.profileRemovingAlert") }}:

        <span>
          {{ devicesNames }}
        </span>
      </div>

      <div v-else>
        {{ `Delete ${child.name}?` }}
      </div>

      <div class="btn-group">
        <base-button color="primary"
                     :rounded="false"
                     :loading="loading"
                     @click="removeProfile">
          {{ $t("remove") }}
        </base-button>

        <base-button color="secondary"
                     class="cancel-btn"
                     :rounded="false"
                     @click="close">
           {{ $t("cancel") }}
        </base-button>
      </div>
    </div>
  </base-modal>
</template>

<script>
  import modalMixin from '@/mixins/modalMixin.js'
  import errorNotification from '@/mixins/errorNotification.js'
  import analytics from '@/services/analytics.js'

  export default {
    mixins: [
      modalMixin,
      errorNotification
    ],

    data() {
      return {
        loading: false,
        fromBus: {
          childId: ''
        }
      }
    },

    methods: {
      removeProfile() {
        this.loading = true
        analytics.sendEvent('Pk_DelCh_EditCh')

        this.removeChild(this.fromBus.childId)
          .then(() => {
            this.close()
            this.$router.push({ name: 'overview' })
            this.$notify({
              type: 'success',
              text: 'Profile successfully deleted'
            })

            this.loading = false
          }).catch(() => {
            this.loading = false
            this.failedRequestNotification()
          })

      },

      ...mapActions('children', {
        removeChild: 'removeChild'
      })
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.fromBus.childId)
      },

      devices() {
        return this.child.devices
      },

      devicesNames() {
      let names = this.devices.map(device => device.name)

      return names.join(', ')
      }
    },

    beforeMount() {
      this.setOpenListener('removeProfile')
    }
  }
</script>

<style lang="scss" scoped>
  .remove-profile {
    .btn-group {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      margin-top: 24px;

      .cancel-btn {
        margin-left: 10px;
      }
    }
  }
</style>